export default __webpack_public_path__ + "static/banner-bg-e9ff2dc23c45d10577d080b4d3a91c41.png";